export const Frame = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="242"
      height="241"
      viewBox="0 0 242 241"
      fill="none"
      className="pointer-events-none absolute end-0 top-0 z-0"
    >
      <path
        d="M273.946 48.3036L250.87 50.8971L269.125 211.925L292.201 209.331L273.946 48.3036Z"
        fill="#EDEAE4"
      />
      <path
        d="M226.179 110.046L111.117 224.653L127.54 241L242.603 126.393L226.179 110.046Z"
        fill="#EDEAE4"
      />
      <path
        d="M2.59664 109.598L0 132.575L161.731 150.695L164.328 127.718L2.59664 109.598Z"
        fill="#EDEAE4"
      />
      <path
        d="M25.2879 -46.6061L5.62644 -34.3018L92.2329 102.899L111.894 90.595L25.2879 -46.6061Z"
        fill="#EDEAE4"
      />
      <path
        d="M140.199 -134L86.4607 18.9618L108.381 26.5964L162.119 -126.365L140.199 -134Z"
        fill="#EDEAE4"
      />
      <path
        d="M232.19 -24.7659L219.836 -5.18703L357.646 81.022L370 61.4431L232.19 -24.7659Z"
        fill="#EDEAE4"
      />
      <path
        d="M273.969 48.3077L250.892 50.8971L269.119 211.928L292.195 209.338L273.969 48.3077Z"
        fill="#EDEAE4"
      />
      <path
        d="M226.157 110.059L111.074 224.646L127.495 240.996L242.578 126.409L226.157 110.059Z"
        fill="#EDEAE4"
      />
    </svg>
  );
};
